import React from "react";
import Textarea from "react-textarea-autosize";
import cx from "classnames";
import PropTypes from "prop-types";

import TitledContainer, { StaticText } from "../TitledContainer";

import styles from "./TitledTextarea.css";

export default class TitledText extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isFocused: false,
      isEdit: props.isEdit || false,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleEdit = this.handleEdit.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      isFocused: !nextProps.isEdit ? false : this.state.isFocused,
      isEdit: nextProps.isEdit,
    });
  }

  handleEdit() {
    this.setState({ isEdit: true, isFocused: true }, () => {
      if (this.props.onEdit) this.props.onEdit();
    });
  }

  handleChange(e) {
    this.props.onChange(e.target.value);
  }

  render() {
    const { border, isReadOnly, isRequired, maxRows, minRows, placeholder, title, value } =
      this.props;
    const { isEdit, isFocused } = this.state;

    return (
      <TitledContainer
        isEdit={isEdit}
        isEmpty={!value}
        onEdit={this.handleEdit}
        title={title}
        isEditable
      >
        {isEdit ? (
          <Textarea
            autoFocus={isFocused}
            className={cx(styles.root, styles[`${border}Border`], {
              [styles.required]: isRequired,
            })}
            maxRows={maxRows}
            minRows={minRows}
            onChange={this.handleChange}
            placeholder={isEdit ? placeholder : "-"}
            readOnly={isReadOnly}
            ref={(ref) => {
              this.input = ref;
            }}
            value={value}
          />
        ) : (
          <StaticText text={value} />
        )}
      </TitledContainer>
    );
  }
}

TitledText.propTypes = {
  minRows: PropTypes.number,
  maxRows: PropTypes.number,
  placeholder: PropTypes.string,
  title: PropTypes.string,
  value: PropTypes.string,
  isEdit: PropTypes.bool,
  isReadOnly: PropTypes.bool,
  isRequired: PropTypes.bool,
  border: PropTypes.oneOf(["bottom", "left"]),
  onChange: PropTypes.func,
  onEdit: PropTypes.func,
};

TitledText.defaultProps = {
  border: "bottom",
  placeholder: "",
  minRows: 2,
  maxRows: 3,
};
